import React, { useState } from "react";
import "./Dashboard.css";
import { Card, Col, Row, Select } from "antd";
import { dayjs } from "../../Utilities/dayjs";
import { Dayjs } from "dayjs";
import SubmissionCard from "./SubmissionCard";
import PracticeUserCard from "./PracticeUserCard";
import InvoiceCard from "./InvoiceCard";
import UpdateCard from "./UpdateCard";
import HolidayCard from "./HolidayCard";
import HeaderStats from "./HeaderStats";
import CustomRangePicker from "../../Common/Custom Components/Ant design/RangePicker";
import { usePractice } from "../../Context/PracticeContext";

const Dashboard = () => {
  const [selectedDate, setSelectedDate] = useState<Dayjs[]>([dayjs().startOf('month'), dayjs().endOf("day")]);
  const [selectPId, setSelectPId] = React.useState<number | null>(null);
  const { allPracticeIds } = usePractice();
  const isLiveURL = window.location.origin === "https://admin.actingoffice.com";

  const removePractice = new Set([6, 10]);
  const filteredPracticeIds = isLiveURL ? allPracticeIds?.filter((p) => !removePractice.has(p.value)) : allPracticeIds;

  React.useEffect(() => {
    if (filteredPracticeIds?.length > 0 && !selectPId) {
      setSelectPId(filteredPracticeIds[0].value);
    }
  }, [filteredPracticeIds, selectPId]);

  return (
    <>
      {/* Header */}
      <Row style={{ backgroundColor: '#fff', padding: '12px 24px' }} justify={"end"}>
        {/* <Col style={{ fontSize: 14 }}></Col> */}
        <Col >
          <CustomRangePicker
            value={[selectedDate[0], selectedDate[1]]}
            allowClear={false}
            onChange={(dates) => {
              setSelectedDate([dayjs(dates[0]), dayjs(dates[1])]);
            }}
          />
        </Col>
      </Row>

      {/* Financial Stats  */}
      <HeaderStats fromDate={selectedDate[0].format("DD-MM-YYYY")} toDate={selectedDate[1].format("DD-MM-YYYY")} />

      {/* Submissions & Invoices Row */}
      <div style={{ padding: "8px 24px 24px" }}>
        <div className="shadowLight roundedCornerMedium bg-white" style={{ border: '2px solid #e0efff', overflow: 'hidden' }}>
          {/* Header */}
          <div style={{
            padding: '12px 24px',
            borderBottom: '1px solid #e0efff',
            background: 'linear-gradient(90deg,  #f0f7ff81 100%)',
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 10
          }}>

            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span className="fs13 fw600 color">Practice:</span>
              <Select
                value={selectPId}
                onChange={setSelectPId}
                style={{ width: 250, height: 28 }}
                placeholder="Select Practice"
                showSearch
                filterOption={(input: any, option: any) => {
                  return option?.label
                    ?.toLowerCase()
                    .includes(input.toLowerCase());
                }}
                options={filteredPracticeIds}
              />
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: 24 }}>
            <Row gutter={[24, 24]}>
              <Col xs={24} lg={12}>
                <Card
                  title={<span className="fs15 fw600">Total Submissions by Category</span>}
                  className="borderlight rounded box-shadow-none"
                  style={{ minHeight: 360 }}
                  styles={{ body: { padding: 0, position: "relative", top: "-20px" } }}
                >
                  <SubmissionCard practiceId={selectPId} fromDate={selectedDate[0].format("DD-MM-YYYY")} toDate={selectedDate[1].format("DD-MM-YYYY")} />

                </Card>
              </Col>
              <Col xs={24} lg={12}>
                <Card
                  title={<span className="fs15 fw600">Invoices by Type/Category</span>}
                  className="borderlight rounded box-shadow-none"
                  style={{ minHeight: 360 }}
                  styles={{ body: { padding: 0, position: "relative", top: "-20px" } }}
                >
                  <InvoiceCard practiceId={selectPId} fromDate={selectedDate[0].format("DD-MM-YYYY")} toDate={selectedDate[1].format("DD-MM-YYYY")} />

                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Practices Users */}
      <Card
        style={{ margin: "0px 24px" }}
        title={<span className="fs15 fw600">Practices Users</span>}
        styles={{
          body: {
            padding: 0, position: "relative", top: "-20px",
            left: "-18px"
          }
        }}
      >
        <PracticeUserCard fromDate={selectedDate[0].format("DD-MM-YYYY")} toDate={selectedDate[1].format("DD-MM-YYYY")} />
      </Card>

      {/* Update Release & Holiday */}
      <div style={{ padding: "8px ", marginTop: 10 }}>
        <Row gutter={[16, 16]} style={{ padding: "8px 18px" }} align="stretch">
          <Col xs={24} lg={12} style={{ display: "flex" }}>
            <UpdateCard fromDate={selectedDate[0].format("DD-MM-YYYY")} toDate={selectedDate[1].format("DD-MM-YYYY")} />
          </Col>
          <Col xs={24} lg={12} style={{ display: "flex" }}>
            <HolidayCard fromDate={selectedDate[0].format("DD-MM-YYYY")} toDate={selectedDate[1].format("DD-MM-YYYY")} />
            {/* <InvoiceCard practiceIds={practiceIds} /> */}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
